import script from "./ClientDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ClientDetail.vue?vue&type=style&index=0&id=0f9dbbed&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9dbbed"]])

export default __exports__